<mat-form-field class="w-full" *ngIf="options">
  <mat-label>{{ label | translate }}</mat-label>

  <input type="text" matInput [formControl]="myControl"
    placeholder="{{ placeholder | translate }}"
    (blur)="onBlur()"
    [required]="required"
    [matAutocomplete]="auto" />

  <button *ngIf="myControl?.value" mat-icon-button matSuffix (click)="clear()"
    tabindex="-1">
    <span class="material-symbols-outlined">close</span>
  </button>

  <mat-autocomplete #autoInput #auto="matAutocomplete" [displayWith]="displayFn.bind(this)"
    (optionSelected)="onAutoCompleteSelect($event)">

    <mat-option *ngFor="let option of filteredOptions" [value]="option">{{displayFn(option)}}</mat-option>

    <mat-option [value]="'otherInsertText'" *ngIf="!requireMatch && !myControl!.value">
      <span>{{ 'otherInsertText' | translate }}</span>
    </mat-option>


  </mat-autocomplete>

  <mat-error *ngIf="myControl!.hasError('required')">{{ 'required' | translate }}</mat-error>
  <mat-error *ngIf="myControl!.hasError('incorrect')">{{ 'required' | translate }}</mat-error>
</mat-form-field>
